<template>
  <div id="app" class="main-content dashboard">
    <div class="row">
      <div class="dash-item col-sm-6">
        <router-link slot="item-title" to="/auditor/clients">
          <div class="dashbox">
            <div class="desc">
              <span v-if="isLoaded" class="amount" >{{ getContacts }}</span>
              <span class="title">{{ $t('dashboard.cards.clients') }} </span>
            </div>
            <div class="icon">
              <contact-icon class="card-icon" />
            </div>
          </div>
        </router-link>
      </div>
      <div class="dash-item col-sm-6">
        <router-link slot="item-title" to="/auditor/invoices">
          <div class="dashbox">
            <div class="desc">
              <span v-if="isLoaded" class="amount">{{ getInvoices }}</span>
              <span class="title">{{ $t('dashboard.cards.invoices') }}</span>
            </div>
            <div class="icon">
              <invoice-icon class="card-icon" />
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import PieChart from '../../components/chartjs/PieChart'
import BarChart from '../../components/chartjs/BarChart'
import DollarIcon from '../../components/icon/DollarIcon'
import ContactIcon from '../../components/icon/ContactIcon'
import InvoiceIcon from '../../components/icon/InvoiceIcon'
import EstimateIcon from '../../components/icon/EstimateIcon'
export default {
  components: {
    PieChart,
    BarChart,
    DollarIcon,
    ContactIcon,
    InvoiceIcon,
    EstimateIcon},
  data () {
    return {
      hoverBgColors: [],
      bgColors: ['#334CFF', '#E333FF', '#33FF71', '#F9FF33', '#FFB233', '#FF3F33'],
      bgCreditLimitColors: ['#33FF71', '#FF3F33'],
      CrditLimitLabels: null,
      labels: ['Pending', 'Offered', 'Financed', 'Prepaid', 'Settlement', 'Rejected'],
      isLoaded: false,
      years: ['This year', 'Previous year'],
      selectedYear: 'This year',
      selectedCustomer: null,
      updateChart: false,
      CreditLimitData: [],
      fundedAmount: 0,
      total_credit_limit: 0
    }
  },
  computed: {
    ...mapGetters('auditorDashboard', [
      'getInvoices',
      'getContacts',
      'invoiceGroupCount'
    ]),
    ...mapGetters('customer', [
      'customers'
    ]),
    ...mapGetters('currency', [
      'defaultCurrency'
    ]),
    totalinvoiceGroup () {
      return this.invoiceGroupCount.reduce((acc, item) => acc + item, 0)
    },
    customerOption () {
      let customerArray = this.customers.slice()
      customerArray.unshift({'id': null, 'company_name': 'All'})
      return customerArray
    }
  },
  watch: {},
  created () {},
  methods: {
    ...mapActions('auditorDashboard', [
      'loadData'
    ]),
  }
}
</script>
